import React from 'react';
import Modal from 'react-responsive-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  content: string;
  onCloseText: string;
  onCancel: () => void;
}

const AlertModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onCancel,
  title,
  content,
  onCloseText,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      center
      classNames={{
        overlay: 'alertModalWrap',
        modal: 'alertModalContainer',
      }}
      showCloseIcon={false}
      animationDuration={150}>
      <div className="alertModal">
        <div className="header">
          <h2>{title}</h2>
          <button onClick={onCancel}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="닫기" />
          </button>
        </div>
        <p>{content}</p>
        <div className="buttonWrap">
          <button onClick={onCancel} className="closeButton">
            {onCloseText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
